import { MdClose } from "react-icons/md";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { logoutRequest } from "services/authRequests";
import { motion } from "framer-motion";

interface ProfilePanelProps {
  firstName: string;
  lastName: string;
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const ProfilePanel: React.FC<ProfilePanelProps> = ({
  firstName,
  lastName,
  setShowPopUp,
}) => {
  // Navigate hook
  const navigate = useNavigate();

  /**
   * Handle logout
   */
  const handleLogout = async () => {
    // Remove the cookies
    Cookies.remove("accessToken");
    // Send the request to delete the refreshToken from the backend
    const response = await logoutRequest();

    // And go to the home page
    navigate("/");
  };

  return (
    <>
      <motion.div
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={() => setShowPopUp(false)}
      />
      <motion.div
        className="fixed w-[462px] h-fit max-h-[90%] left-0 right-0 ml-auto mr-auto bottom-4 px-6 pt-6 pb-8 bg-white rounded-3xl flex-col justify-start items-start gap-14 inline-flex z-30 overflow-hidden"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
      >
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="grow shrink basis-0 text-neutral-700 text-[23px] font-semibold font-sans leading-7">
            My Profile
          </div>
          <button
            className="p-2 bg-neutral-50 rounded-full backdrop-blur-[32px] justify-center items-center gap-2 flex cursor-pointer hover:bg-neutral-100 ease-in-out duration-150"
            onClick={() => setShowPopUp(false)}
          >
            <div className="w-5 h-5 relative">
              <MdClose className="w-full h-full fill-neutral-700" />
            </div>
          </button>
        </div>
        <div className="self-stretch h-fit flex-col justify-start items-start gap-14 flex">
          <div className="self-stretch h-fit flex-col justify-start items-start gap-5 flex">
            <div className="self-stretch text-neutral-500 text-base font-semibold font-sans leading-[19px]">
              Profile details
            </div>
            <div className="self-stretch h-fit flex-col justify-start items-start gap-4 flex">
              <div className="self-stretch h-fit flex-col justify-start items-start flex">
                <div className="rounded justify-start items-start gap-2 inline-flex">
                  <div className="text-neutral-500 text-xs font-normal font-sans uppercase leading-[14px] tracking-wide">
                    First Name
                  </div>
                </div>
                <div className="self-stretch py-1 justify-center items-center gap-2 inline-flex">
                  <div className="grow shrink basis-0 h-[19px] text-neutral-700 text-lg font-semibold font-sans leading-snug">
                    {firstName}
                  </div>
                </div>
              </div>
              <div className="self-stretch h-fit flex-col justify-start items-start flex">
                <div className="rounded justify-start items-start gap-2 inline-flex">
                  <div className="text-neutral-500 text-xs font-normal font-sans uppercase leading-[14px] tracking-wide">
                    Last Name
                  </div>
                </div>
                <div className="self-stretch py-1 justify-center items-center gap-2 inline-flex">
                  <div className="grow shrink basis-0 h-[19px] text-neutral-700 text-lg font-semibold font-sans leading-snug">
                    {lastName}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="self-stretch h-fit flex-col justify-start items-start gap-5 flex">
            <div className="self-stretch text-neutral-500 text-base font-semibold font-sans leading-[19px]">
              Platform guide
            </div>
            <div className="self-stretch h-fit flex-col justify-start items-start gap-4 flex">
              <div
                className={
                  guide === "jakita"
                    ? "self-stretch p-4 bg-neutral-50 rounded-xl border-2 border-neutral-700 justify-start items-center gap-4 inline-flex cursor-pointer"
                    : "self-stretch p-4 bg-neutral-50 rounded-xl border-2 border-transparent justify-start items-center gap-4 inline-flex cursor-pointer"
                }
                onClick={() => setGuide("jakita")}
              >
                <img className="w-10 h-10 rounded-full" src={Jakita} />
                <div className="grow shrink basis-0 h-[19px] text-neutral-700 text-lg font-semibold font-sans leading-snug">
                  Jakita
                </div>
                <div className="w-8 h-8 justify-center items-center flex">
                  <div className="w-8 h-8 relative">
                    {guide === "jakita" ? (
                      <MdCheckCircle className="w-full h-full fill-neutral-700" />
                    ) : (
                      <MdRadioButtonUnchecked className="w-full h-full fill-neutral-500" />
                    )}
                  </div>
                </div>
              </div>
              <div
                className={
                  guide === "littleC"
                    ? "self-stretch p-4 bg-neutral-50 rounded-xl border-2 border-neutral-700 justify-start items-center gap-4 inline-flex cursor-pointer"
                    : "self-stretch p-4 bg-neutral-50 rounded-xl border-2 border-transparent justify-start items-center gap-4 inline-flex cursor-pointer"
                }
                onClick={() => setGuide("littleC")}
              >
                <img className="w-10 h-10 rounded-full" src={LittleC} />
                <div className="grow shrink basis-0 h-[19px] text-neutral-700 text-lg font-semibold font-sans leading-snug">
                  Little C
                </div>
                <div className="w-8 h-8 relative">
                  {guide === "littleC" ? (
                    <MdCheckCircle className="w-full h-full fill-neutral-700" />
                  ) : (
                    <MdRadioButtonUnchecked className="w-full h-full fill-neutral-500" />
                  )}
                </div>
              </div>
            </div>
            <div
              className="self-stretch px-5 py-3 bg-secondary-600 rounded justify-center items-center gap-2 inline-flex cursor-pointer"
              onClick={handleLogout}
            >
              <div className="text-white text-lg font-semibold font-sans leading-snug">
                Logout
              </div>
            </div>
          </div> */}
        </div>
      </motion.div>
    </>
  );
};

export default ProfilePanel;
